module.exports = (
  $scope,
  $rootScope,
  $state,
  Api,
  subject,
  countries,
  countryAliases
) ->

  $scope.countries = ({ id: c.iso_code, name: c.name, aliases: countryAliases[c.name] } for c in countries when c.iso_code != "glo")

  $scope.subject = subject or new Api.MonitoringSubjects
    dob_precision: 'D',
    name_match_precision: 'exact',
    frequency: 'W',
    type: 'individual'
  $scope.originalSubject = angular.copy($scope.subject)

  $scope.saveSubject = (subjectForm) ->
    subjectForm.$submitted = true
    if !subjectForm.$valid
      return

    if $scope.subject.type == 'company'
      $scope.subject.middle_name = null
      $scope.subject.last_name = null
      $scope.subject.dob_precision = null
      $scope.subject.dob_day = null
      $scope.subject.dob_month = null
      $scope.subject.dob_year = null

    # Hack to set country to null if it is undefined
    if not $scope.subject.country?
      $scope.subject.country = null

    save = if $scope.subject.id then $scope.subject.$update() else $scope.subject.$save()
    save.then ->
      $state.go('subject.alerts', { subjectId: $scope.subject.id })
      $rootScope.message = 'Subject successfully saved'

  $scope.cancelChanges = ->
    if $scope.subject.id
      angular.copy($scope.originalSubject, $scope.subject)
      $state.go('subject.alerts', { subjectId: $scope.subject.id })
    else
      $state.go('monitoring')

  $scope.findRelatedSubjects = () ->
    if $scope.subject.first_name
      if $scope.subject.type == 'company'
        subject = {
          first_name: $scope.subject.first_name,
          type: $scope.subject.type
        }
      else
        subject = {
          first_name: $scope.subject.first_name,
          middle_name: $scope.subject.middle_name,
          last_name: $scope.subject.last_name,
          type: $scope.subject.type
        }

      Api.MonitoringSubjects.get(subject).$promise.then (response) ->
        $scope.relatedSubjects = response.results
